import { render, staticRenderFns } from "./TemplatesPreview.vue?vue&type=template&id=406edbf6&scoped=true"
import script from "./TemplatesPreview.vue?vue&type=script&lang=js"
export * from "./TemplatesPreview.vue?vue&type=script&lang=js"
import style0 from "./TemplatesPreview.vue?vue&type=style&index=0&id=406edbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406edbf6",
  null
  
)

export default component.exports